var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5829 2.5695C19.4696 2.16552 19.249 1.79978 18.9445 1.51116C18.6314 1.21367 18.2477 1.00086 17.8295 0.892829C16.2645 0.480329 9.99454 0.480329 9.99454 0.480329C7.38065 0.450589 4.7674 0.581391 2.16954 0.871995C1.75136 0.988006 1.36834 1.20557 1.05454 1.50533C0.746204 1.802 0.522871 2.16783 0.406204 2.56866C0.125949 4.07845 -0.0102189 5.61145 -0.000462243 7.147C-0.0104622 8.68116 0.125371 10.2137 0.406204 11.7253C0.520371 12.1245 0.742871 12.4887 1.05204 12.7828C1.3612 13.077 1.7462 13.2895 2.16954 13.402C3.75537 13.8137 9.99454 13.8137 9.99454 13.8137C12.6118 13.8434 15.2283 13.7126 17.8295 13.422C18.2477 13.314 18.6314 13.1012 18.9445 12.8037C19.2489 12.5151 19.4693 12.1493 19.582 11.7453C19.8696 10.2361 20.0094 8.70249 19.9995 7.16616C20.0212 5.62333 19.8815 4.08247 19.5829 2.56866V2.5695ZM8.0012 10.0003V4.2945L13.2179 7.14783L8.0012 10.0003Z",
    fill: "#112211"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube_icon.a6d736e6d482c2da54d3ad13d20cc0dc.svg";
export { ForwardRef as ReactComponent };